/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * EQUAL operator looks for values that are equal to the given value.
 */
export interface EqualDid {
    /** The value to compare against. */
    value: string;
}
